<template>
  <div class="layout-frame">
    <PageIntro :title="t('resetPassword.title')" />
    <!-- <ResetPasswordForm /> -->
  </div>
</template>

<script setup lang="ts">
// import ResetPasswordForm from '@modules/ResetPasswordForm.vue';
import { useI18n } from 'vue-i18n';

import PageIntro from '@modules/PageIntro.vue';

const { t } = useI18n();
</script>
